import { ActionControllerEventName, ButtonComponent, ParentEvent, TextComponent, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import { BUTTON_PRIMARY_COLOR, BUTTON_PRIMARY_TEXT_COLOR, MENU_BACKGROUND_COLOR, PRIMARY_TEXT_COLOR } from '../styleConfig';
import { Vector2, Vector3 } from 'three';
import { FuturisticWindow } from "./FuturisticWindow";
export default class ModalPanel extends ViewerModule {
    constructor(twoButtons, isWelcomScreen = false) {
        super();
        this.twoButtons = twoButtons || false;
        this.addObject(this.background = new FuturisticWindow({
            size: new Vector2(8.45, 5),
            radius: 0.01,
            type: 3,
            hasSideImage: true
        }));
        this.background.uiObject.scale.setScalar(0.085);
        const sizeCoef = isWelcomScreen ? 4 : 10;
        this.addObject(this.header = new TextComponent({
            size: new Vector2(6 / sizeCoef, 1.5 / sizeCoef),
            pxSize: new Vector2(512, 128).multiplyScalar(window['quality'] === 'very low' ? 1 : 1),
            text: {
                style: { size: `${32 * (window['quality'] === 'very low' ? 1 : 1)}px`, family: 'Nunito', weight: '800', color: PRIMARY_TEXT_COLOR.getStyle() },
                lineHeight: 40 * (window['quality'] === 'very low' ? 1 : 1),
                value: '',
                autoWrappingHorizontal: true,
                margin: { bottom: 18 }
            },
            background: { color: 'transparent' }
        }));
        this.header.uiObject.position.z = 0.02;
        this.header.uiObject.position.y = isWelcomScreen ? 0.13 : 0.075;
        // buttons
        const sizeX = 5 / 10;
        const sizeY = 5 / 10;
        const sizeZ = 1 / 10;
        this.addObject(this.button = new ButtonComponent({
            type: 'flat',
            size: new Vector3(sizeX, sizeY, sizeZ),
            sizePx: new Vector2(256, 256),
            bordRadius: 0.01,
            background: { color: BUTTON_PRIMARY_COLOR.getStyle() },
            text: {
                value: 'Start',
                lineHeight: 16,
                style: { size: '21px', color: BUTTON_PRIMARY_TEXT_COLOR.getStyle(), family: 'Nunito', weight: '800' },
                margin: { top: 12, right: 35, bottom: 12, left: 35 },
            }
        }));
        // this.button.on(ActionControllerEventName.click, () => this.fire('buttonClick'));
        this.button.on(ActionControllerEventName.click, () => this.fire('ok', new ParentEvent('ok')));
        this.button.uiObject.position.y = -0.12;
        this.button.uiObject.position.z = 0.02;
        this.addObject(this.buttonThird = new ButtonComponent({
            type: 'flat',
            size: new Vector3(sizeX, sizeY, sizeZ),
            sizePx: new Vector2(256, 256),
            bordRadius: 0.01,
            background: { color: MENU_BACKGROUND_COLOR.getStyle() },
            text: {
                value: 'Close',
                lineHeight: 16,
                style: { size: '21px', color: BUTTON_PRIMARY_TEXT_COLOR.getStyle(), family: 'Nunito', weight: '800' },
                margin: { top: 12, right: 25, bottom: 12, left: 25 },
            }
        }));
        this.buttonThird.uiObject.visible = false;
        this.buttonThird.on(ActionControllerEventName.click, () => this.uiObject.visible = false);
        if (this.twoButtons) {
            this.addObject(this.buttonSecond = new ButtonComponent({
                type: 'flat',
                size: new Vector3(sizeX, sizeY, sizeZ),
                sizePx: new Vector2(256, 256),
                bordRadius: 0.01,
                background: { color: MENU_BACKGROUND_COLOR.getStyle() },
                text: {
                    value: 'Exit',
                    lineHeight: 16,
                    style: { size: '21px', color: BUTTON_PRIMARY_TEXT_COLOR.getStyle(), family: 'Nunito', weight: '800' },
                    margin: { top: 12, right: 25, bottom: 12, left: 25 },
                }
            }));
            // this.buttonSecond.on(ActionControllerEventName.click, () => this.fire('buttonSecondClick'));
            this.buttonSecond.on(ActionControllerEventName.click, () => {
                this.uiObject.visible = false;
                this.fire('exit', new ParentEvent('exit'));
            });
            this.buttonSecond.uiObject.position.set(0.2, -0.12, 0.02);
        }
        this.calcButtonsPosition();
    }
    calcButtonsPosition() {
        // move first button
        this.button.uiObject.position.x = -0.17;
        this.buttonSecond.uiObject.position.x = 0.2;
        if (this.buttonThird.uiObject.visible) {
            ViewerModule.adjustObjects([this.button, this.buttonThird, this.buttonSecond].map(el => el.uiObject), true, 0.04);
            [this.button, this.buttonThird, this.buttonSecond].forEach(btn => btn.uiObject.position.y = -0.12);
        }
    }
    init(mainText, buttonText, secondButtonText, thirdButton) {
        this.background.init();
        this.header.setText(mainText);
        this.button.setText(buttonText ? buttonText : 'OK');
        this.buttonSecond && this.buttonSecond.setText(secondButtonText ? secondButtonText : 'EXIT');
        if (thirdButton) {
            this.buttonThird.uiObject.visible = true;
        }
        this.calcButtonsPosition();
    }
}
